/** Organization experimental feature: real factories (tasks, lines, factory apps). */
export const FEATURE_FACTORIES = "factories";

/** Organization experimental feature: Claude managed agents on the canvas. */
export const FEATURE_CLAUDE_MANAGED_AGENTS = "claude_managed_agents";

/** Organization experimental feature: SetupProvider wizard for GitHub and similar integrations. */
export const FEATURE_NEW_INTEGRATION_SETUP_FLOW = "new_integration_setup_flow";

/** Organization experimental feature: manual "Add intake" entry for Jira in the Backlog column menu. */
export const FEATURE_FACTORY_JIRA_INTAKE = "factory_jira_intake";

/** Organization experimental feature: manual "Add intake" entry for Productive.io in the Backlog column menu. */
export const FEATURE_FACTORY_PRODUCTIVE_INTAKE = "factory_productive_intake";

/** Organization experimental feature: Datadog Error Tracking intake from the Backlog column menu. */
export const FEATURE_FACTORY_DATADOG_INTAKE = "factory_datadog_intake";

/** Organization experimental feature: Linear issue intake from the Backlog column menu. */
export const FEATURE_FACTORY_LINEAR_INTAKE = "factory_linear_intake";

/** Organization experimental feature: Bitbucket as a workspace Git host. */
export const FEATURE_FACTORY_BITBUCKET = "factory_bitbucket";

/** Organization experimental feature: workspace MCP servers. */
export const FEATURE_WORKSPACE_MCP = "workspace_mcp";

/** Organization experimental feature: workspace skills. */
export const FEATURE_WORKSPACE_SKILLS = "workspace_skills";

/** Organization experimental feature: organization LLM Models (BYOK) settings page. */
export const FEATURE_ORGANIZATION_BYOK = "organization_byok";

/** Organization experimental feature: custom model provider on the BYOK settings page. Requires organization BYOK. */
export const FEATURE_ORGANIZATION_BYOK_CUSTOM_PROVIDER = "organization_byok_custom_provider";

/** Organization experimental feature: blank custom automations on Verify, Done, and phase columns. */
export const FEATURE_FACTORY_CUSTOM_AUTOMATIONS = "factory_custom_automations";

/** Organization experimental feature: Mergeable chip on task cards and Merge button on pull request review. */
export const FEATURE_FACTORY_PULL_REQUEST_MERGE = "factory_pull_request_merge";

/** Organization experimental feature: public workspace MCP server for Cursor and other MCP clients. */
export const FEATURE_SUPERPLANE_MCP_SERVER = "superplane_mcp_server";

/** Organization experimental feature: mobile workspace shell on phone-width screens. */
export const FEATURE_MOBILE_FACTORY_BOARD = "mobile_factory_board";
